import React from 'react';
import PropTypes from 'prop-types';

import MenuItemDetail from 'bento-ordering/menus/containers/MenuItemDetail';

class MenuItemDetailRoute extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <MenuItemDetail {...this.props} />
      </React.Fragment>
    );
  }
}

export default MenuItemDetailRoute;
